import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'

export default class InputDataList extends Component {
    constructor(...props) {
        // noinspection JSCheckFunctionSignatures
        super(...props);
        // 性能优化向
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

    }

    render() {
        // noinspection JSUnresolvedVariable
        let listId = this.props.listId;
        return (
            <div style={styles.divStyles}>
                <input className="inputDataList" id={this.props.inputId} type={'number'}
                       onChange={this.props.yearOnChange.bind(this)}
                       style={styles.inputStyle}
                       list={listId}
                       value={this.props.defaultValue}
                />
                <datalist id={listId}>
                    {
                        "<!--[if IE]><select><!--<![endif]-->"
                    }

                    {
                        this.props.options.map((option, index) => {
                            return (
                                <option key={index} value={option}/>
                            )
                        })
                    }

                    {
                        "<!- etc -->"
                    }
                    {
                        "<!--[if IE]><select><!--<![endif]-->"
                    }


                </datalist>
            </div>
        )
    }

    componentDidMount() {
    }
}


const styles = {
    divStyles: {
        display: "inline-block",
    },
    inputStyle: {
        width: '128px',
        height: '36px',
        lineHeight: '36px',
        textIndent: '5px',
        margin: '0 10px',
        // position: 'relative',
        background: 'none',
        border: '1px solid #a9a9a9'
    }
};

InputDataList.defaultProps = {
    yearOnChange: (event) => {
        // console.log(event);
    },
    inputId: "",
    listId: "",
    options: [],
    defaultValue: ''
};




// WEBPACK FOOTER //
// ./src/components/InputDataList.js